export namespace SelinaShare {
    export class SelinaShareManager {

        public config: SelinaShareConfig;

        public templates: any;

        public constructor() {
            this.config = {
                url: 'www.google.com',
                wechatQrcodeTitle: '',
                wechatQrcodeHelper: '',
                wechatQrcode: '',
                description: '',
                title: '',
                image: '',
                origin: '',
                weiboKey: '',
            };
            this.templates = {
                weibo: 'https://service.weibo.com/share/share.php?url={{URL}}&title={{TITLE}}&pic={{IMAGE}}&appkey={{WEIBOKEY}}',
                wechat: '',
                linkedin: 'http://www.linkedin.com/shareArticle?mini=true&ro=true&title={{TITLE}}&url={{URL}}&summary={{SUMMARY}}&source={{SOURCE}}&armin=armin',
                facebook: 'https://www.facebook.com/sharer/sharer.php?u={{URL}}',
                twitter: 'https://twitter.com/intent/tweet?text={{TITLE}}&url={{URL}}&via={{ORIGIN}}',
                google: 'https://plus.google.com/share?url={{URL}}'
            };
        }

        public setConfig(config: SelinaShareConfig) {
            this.config = config;
            console.log(this.config, 'Selina---------------------Configurations Gotten');
            Object.keys(this.templates).map((key: string) => {
                this.templates[key] = this.templates[key]
                    .replace('{{URL}}', config.url)
                    .replace('{{TITLE}}', config.title)
                    .replace('{{IMAGE}}', config.image)
                    .replace('{{WEIBOKEY}}', config.weiboKey)
                    .replace('{{SUMMARY}}', config.title)
                    .replace('{{SOURCE}}', config.title)
                    ;
            });
            console.log('Selina---------------------Configured');
        }

        public async getQrcode(url: string) {}
    }

    export interface SelinaShareConfig {
        url: string;
        origin: string;
        source?: string;
        title: string;
        description: string;
        image: string;
        weiboKey: string;
        wechatQrcodeTitle: string;
        wechatQrcodeHelper: string;
        wechatQrcodeSize?: number;
        wechatQrcode: string;
        sites?: any;
        mobileSites?: any;
    }
}
